import { Action } from 'redux';
import _ from 'underscore';

import { isRequestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Loadable } from '~src/httpClient/utils/Loadable';

import { isBroadcastViewCreatedAction, isBroadcastViewDeletedAction, isGetBroadcastDetailAction, isUpdateBroadcastViewAction } from '../actions/BroadcastActions';
import { BroadcastState } from '../state/BroadcastState';

const initialState: BroadcastState = {
    broadcastStatus: Loadable.notLoaded,
    broadcastDetail: Loadable.notLoaded,
};

export function broadcastReducer(prevState: BroadcastState = initialState, action: Action = null): BroadcastState {
    if (isGetBroadcastDetailAction(action)) {
        return {
            broadcastStatus: Loadable.loading(),
            broadcastDetail: Loadable.loading()
        };
    } else if (isUpdateBroadcastViewAction(action)) {
        if (!_.isUndefined(action.item)) {
            return {
                broadcastStatus: Loadable.loaded(true),
                broadcastDetail: Loadable.loaded(action.item)
            };
        }
        return {
            broadcastStatus: Loadable.loaded(false),
            broadcastDetail: Loadable.loaded(null)
        };
    } else if (isBroadcastViewCreatedAction(action)) {
        return { ...prevState, broadcastStatus: Loadable.loaded(true) };
    } else if (isBroadcastViewDeletedAction(action)) {
        return { broadcastStatus: Loadable.loaded(false), broadcastDetail: Loadable.loaded(null) };
    } else if (isRequestFailed(action)) {
        return { ...prevState, broadcastStatus: Loadable.failed('', prevState.broadcastStatus.content) };
    }
    return prevState;
}
